export const cgPlanSponsors = [
    'planpremier-tpa',
    'janna-hahn',
    'bryan-blankenship',
    'jason-wallace',
    'barney-mbigha',
];
